import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["summary"]

  static values = { url: String }

  async updateSummary() {
    const html = await fetch(this.summaryUrl).then((resp) => resp.text())
    const root = new DOMParser().parseFromString(html, "text/html")
    const node = root.getElementById(this.summaryTarget.id)
    this.summaryTarget.replaceWith(node)
  }

  get summaryUrl() {
    const url = new URL(this.urlValue, location)
    for (const [key, value] of this.formData) {
      if (!key.match(/token|title|description/)) {
        url.searchParams.append(key, value)
      }
    }
    return url
  }

  get formData() {
    return new FormData(this.element)
  }
}
